"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.approve = void 0;
const tslib_1 = require("tslib");
const helpers_1 = require("../helpers");
const constants_1 = require("../constants");
const approveRequest_1 = require("../chat/approveRequest");
const approve = (options) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { status = 'Approved', account = null, signer = null, senderAddress, // space id
    env = constants_1.default.ENV.PROD, pgpPrivateKey = null, } = options || {};
    try {
        if (account == null && signer == null) {
            throw new Error(`At least one from account or signer is necessary!`);
        }
        if (!(0, helpers_1.isValidPushCAIP)(senderAddress) &&
            !senderAddress.startsWith('spaces:')) {
            throw new Error('Not a valid spaceId or ETH address');
        }
        return yield (0, approveRequest_1.approve)({
            status: status,
            account: account,
            signer: signer,
            senderAddress: senderAddress,
            env: env,
            pgpPrivateKey: pgpPrivateKey,
        });
    }
    catch (err) {
        console.error(`[Push SDK] - API  - Error - API ${exports.approve.name} -:  `, err);
        throw Error(`[Push SDK] - API  - Error - API ${exports.approve.name} -: ${err}`);
    }
});
exports.approve = approve;
//# sourceMappingURL=approve.js.map